angular.module('bribac.components.collapsingBox', [])

  .component('collapsingBox', {
    templateUrl: 'collapsing-box-component.html',
    controller: 'CollapsingBoxComponentCtrl',
    bindings: {
      collapsed: '<'
    },
    transclude: {
      header: 'collapsingBoxHeader',
      body: 'collapsingBoxBody'
    }
  })

  .controller('CollapsingBoxComponentCtrl', function() {
    var $ctrl = this

    $ctrl.toggleCollapsed = function() {
      $ctrl.collapsed = !$ctrl.collapsed
    }
  })
